import { Quote } from '@/model/quotesModel';
import { getScalingFactorsForQuote } from '@shared';

export function calculateGapFillPremium(
  quote: Quote,
  totalCost: number,
  projectedCostCoverage: number,
  maxAchievableCoverage: number,
): number {
  const target = Math.min(totalCost, maxAchievableCoverage);
  const linearEstimate = target * (quote.premiumAmount / projectedCostCoverage);

  const { ltc: ltcFactor, outOfRange } = getScalingFactorsForQuote(quote, linearEstimate);

  // When the carrier cannot price linearEstimate the factors come back as inert 1.0s, so the
  // "correction" below collapses to premium/linearEstimate and dividing by it amplifies
  // instead of correcting (a $600k estimate became $3.6M). The uncorrected linear estimate is
  // the honest answer; adjustQuoteForPremium clamps or pins it downstream.
  if (outOfRange) return Math.round(linearEstimate);

  const bandCorrection = ltcFactor / (linearEstimate / quote.premiumAmount);
  if (!bandCorrection) return Math.round(linearEstimate);

  return Math.round(linearEstimate / bandCorrection);
}

export function formatCoveragePercentage(value: number): string {
  return value % 1 < 0.05 ? `${Math.round(value)}` : value.toFixed(1);
}
